module.exports = __webpack_public_path__ + "static/img/detail.fee9e363.png";